<template>
	<el-dropdown-item v-bind="$attrs" v-on="$listeners">
	  <slot></slot>
	</el-dropdown-item>
</template>
<script>
export default {
  name: "aia-dropdown-item",
};
</script>